"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const update = (state) => ({ setState }) => {
    if (state) {
        setState(Object.assign({}, state));
    }
};
exports.default = update;
